// src/index.js (no changes needed)
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
//import { ThemeProvider } from '@mui/material/styles';

import App from './App';
import store from './store/index';
//import theme from './theme';
//import "bootstrap/dist/css/bootstrap.min.css";
//import "bootstrap-icons/font/bootstrap-icons.css";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
      <App />
  </Provider>
);
